import React from "react";
import { FormattedMessage } from "react-intl";
import { Typography } from "@material-ui/core";

const DefaultAgreement = ({ user }) => {
  const { contractAgent } = user;

  return (
    <>
      <Typography
        variant="h6"
        gutterBottom
      >
        LEVEL - {contractAgent?.contractAgentClass?.levelValue ?? "N/D"}
      </Typography>

      {contractAgent?.contractAgentClass?.levelName && (
        <Typography
          variant="h6"
          gutterBottom
        >
          LEVEL NAME - {contractAgent.contractAgentClass.levelName}
        </Typography>
      )}

      <Typography
        variant="body1"
        gutterBottom
      >
        <FormattedMessage id="app.contractAgent.default.message1" />
      </Typography>
      <Typography
        variant="body1"
        gutterBottom
      >
        <FormattedMessage id="app.contractAgent.default.message2" />
      </Typography>
    </>
  );
};

export default DefaultAgreement;
